import React from 'react';

import { lazyWithSuspense } from '@travel/utils';

import Banner from './components/Banner';
import OtherServices from './components/OtherServices';
import ReservationTab from './components/ReservationTab';

import type { Query } from 'ReservationsList-Types';

// Load dialogs client-only to avoid SSR hydration mismatches
const QRCodeDialogue = lazyWithSuspense(() => import('./components/QRCodeDialog'));
const FurusatoCouponSearchDialog = lazyWithSuspense(
  () => import('./components/FurusatoCouponSearchDialog'),
);
const FurusatoErrorDialog = lazyWithSuspense(() => import('./components/FurusatoErrorDialog'), {
  ssr: false,
});
const MobileCouponSearchDialog = lazyWithSuspense(
  () => import('./components/MobileCouponSearchDialog'),
);
const MobileErrorDialog = lazyWithSuspense(() => import('./components/MobileErrorDialog'));

type Props = {
  path: string;
  filter?: string;
  query: Query;
};

const ReservationList = (props: Props) => {
  return (
    <div data-testid="reservation-list">
      <Banner />
      <ReservationTab {...props} />
      <OtherServices />
      <QRCodeDialogue />
      <FurusatoCouponSearchDialog />
      <FurusatoErrorDialog />
      <MobileCouponSearchDialog />
      <MobileErrorDialog />
    </div>
  );
};

export default ReservationList;
